<div *ngIf="model">
  <p class="group-title" [class.collapsed]="isCollapsed" (click)="toggleCollapseState()">{{model.displayName}}</p>
  <div [ngbCollapse]="isCollapsed" class="collapse show">
    <ng-template [ngIf]="!isCollapsed && children">
      <div *ngFor="let child of children" class="child-nodes-wrapper">
        <div *ngIf="child.isObject && child['filtered']; else textNode">
          <object-node [model]="child"
                       [isFiltered]="isFiltered"
                       [isFormReadonly]="isFormReadonly"
                       (formChanged)="formDirty()"></object-node>
        </div>
        <ng-template #textNode>
          <waf-text-input *ngIf="child['filtered']"
                          [label]="child.displayName"
                          [(ngModel)]="child.value"
                          (ngModelChange)="formDirty()"
                          [isReadonlyValue]="isFormReadonly"
                          [maxLength]="500"></waf-text-input>
        </ng-template>
      </div>
    </ng-template>
  </div>
</div>
